import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { BrandMark } from './public/BrandMark.js';

const NAV = [
  { to: '/platform', label: 'Overview', end: true },
  { to: '/platform/organizations', label: 'Organizations' },
  { to: '/platform/users', label: 'Users' },
];

export function PlatformLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="platform-layout">
      <header className="platform-layout__header">
        <BrandMark compact />
        <span className="platform-layout__badge">Platform Administration</span>
        <div className="platform-layout__user">
          {user && <span className="platform-layout__user-name">{user.fullName}</span>}
          <button type="button" className="btn btn--ghost btn--sm" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      </header>
      <div className="platform-layout__body">
        <nav className="platform-layout__nav" aria-label="Platform">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `platform-layout__nav-link ${isActive ? 'platform-layout__nav-link--active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <main className="platform-layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
